<template>
  <div class="viewer-wrapper" style="overflow:hidden;"> 
    <viewer :options="options" :images="images"
             @inited="inited"
             class="viewer" ref="viewer">
      <template slot-scope="scope">
        <figure class="images">
          <div class="image-wrapper" v-for="{source, thumbnail} in scope.images" :key="source">
            <img class="image" style="max-width: 68em; max-height:80em;"
                 :src="thumbnail" :data-source="source" :alt="source.split('?image=').pop()"/>
          </div>
        </figure> 
      </template>
    </viewer>
  </div>
</template>

<script>
export default {
  name: 'imageObj',
  props: [
    'sysId', 'imgId'
  ],
  data() {
    return {
      images: [],    
      img: '',
      options: {
        inline: true,
        button: true,
        navbar: false,
        title: false,
        toolbar: true,
        tooltip: true,
        movable: true,
        zoomable: true,
        rotatable: true,
        scalable: true,
        transition: true,
        fullscreen: true,
        keyboard: true,
        url: 'data-source'
      }
    }
  },
  methods: {
    inited (viewer) {
      this.$viewer = viewer
    }
  },
  created () {
    this.img = './WebApi/Tools/ShowSystemDocByType/'.concat(this.sysId).concat("/").concat(this.imgId)
    this.images.push({
      thumbnail: this.img,
      source: this.img
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
  .viewer-wrapper {
    position: relative;
    background: #333;
    min-height: 24em;
  }
  
</style>


// WEBPACK FOOTER //
// src/components/common/ImageView.vue